<ng-container>
  @if (caseId() || idSignal()) {
  <div
    class="case-summary-background"
    @fadeInOut
  >
    <div
      class="case-summary-header flex flex-row justify-between items-center gap-2 w-full"
    >
      <div class="flex flex-row items-center gap-2 grow app-pr">

        <!-- Toggler -->
        @if (caseId()) {
          <app-more-less-toggler
            class="app-pl"
            [showExpandedSignal]="bitsState.summaryBarExpanded"
          />
        }

        <!-- Data -->
        <div class="flex items-center justify-between case-summary-header grow">
          @if (workflowSummaryModelSig().caseNum) {
            <div class="flex flex-col justify-center gap-1 workflow-fields">
              <span>{{ workflowSummaryModelSig().workflowName }}</span>
              <div class="flex">
                <span class="label">{{ workflowSummaryModelSig().caseNum }}</span>
                <span class="label dot">•</span>
                <span class="label">{{ workflowSummaryModelSig().workflowStepName }}</span>
                <span class="label dot">•</span>
                <span class="value">{{ workflowSummaryModelSig().workflowStepStatus }}</span>
              </div>
            </div>
          }

          @for (item of workflowSummaryModelSig().workflowData; track $index) {
            @if (item == "|") {
              <div class="separator"></div>
            } @else {
              <div class="flex flex-col justify-center items-left gap-0">
                <span class="label">{{ item.label }}</span>
                <span class="value">{{ item.value }}</span>
              </div>
            }
          }
        </div>

      </div>
    </div>
  </div>
  }
</ng-container>
